const howtouseAccordion = document.querySelectorAll('.how_to_use-accorodion');
const howtouseImg = document.querySelector('.how_to_use-img');
const howtouseVideo = document.querySelector('.how_to_use-video');
const howtouseVideoSource = document.querySelector('.how_to_use-video source');
const howtouseDescription = document.querySelector('.how_to_use-description');
const contentBanner = document.querySelector('.content__banner');

const images = ["jpg", "gif", "png", "webp"]
const videos = ["mp4", "3gp", "ogg"]
// howtouseVideo.style.display = "none";

function get_url_extension( url ) {
    return url.split(/[#?]/)[0].split('.').pop().trim();
}

howtouseAccordion?.forEach(accordion => {
    accordion.addEventListener('click', event => {
    event.preventDefault();
        const data_extension = get_url_extension(accordion.dataset.url)
    
        if (images.includes(data_extension)) {
            howtouseVideo.style.display = "none";
            howtouseImg.style.display = "block";
            howtouseImg.src = accordion.dataset.url;
            if (howtouseVideo) {
            howtouseVideo.pause()
            }
        } else if (videos.includes(data_extension)) {
            howtouseImg.style.display = "none";
            howtouseVideo.style.display = "block";
            howtouseVideo.load();
            howtouseVideo.play();
            howtouseVideo.parentElement.classList.remove('visible');
            howtouseVideoSource.src = accordion.dataset.url;
            howtouseVideo.setAttribute("controls", true );
            howtouseVideo.addEventListener('loadedmetadata', function() {
                console.log("Starting to load video");
                setTimeout(() => {
                    howtouseVideo.parentElement.classList.add('visible');
                }, 400)
            }, false);

        }
    });
});
if (howtouseAccordion[0]) {
    howtouseAccordion[0].click();
howtouseAccordion[0].querySelector('.accordion_button').click();
}


const desc_extension = get_url_extension(howtouseDescription?.dataset.url)
if (images.includes(desc_extension)) {
    howtouseVideo.style.display = "none";
    howtouseImg.style.display = "block";
    howtouseImg.src = howtouseDescription.dataset.url;
} else if (videos.includes(desc_extension)) {
    howtouseImg.style.display = "none";
    howtouseVideo.style.display = "block";
    howtouseVideoSource.src = howtouseDescription.dataset.url;
    howtouseVideo.load();
    howtouseVideo.play();
}

